import { TOGGLE_PRIMARY_IMAGE } from 'actions/productDetailsActions';

export default function productImage(state = { defaultMedia: null }, action) {
	switch (action.type) {
		case TOGGLE_PRIMARY_IMAGE:
			return Object.assign({}, state, { defaultMedia: action.image });
		default:
			return state;
	}
}
